import React from 'react'
import PropTypes from 'prop-types';
import {useLocation } from "react-router-dom";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import THContent from '../Tracks/DeliveryLeadership/function-components/THContent';
import Requestor from './BusinessPOC/SessionDetailsToNominateTabs';
import Typography from '@mui/material/Typography';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Track = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const location = useLocation();
  const track = location.state || {};
  const tabs = [];
  if (
  track?.roles?.some(
    (val) => val.role === "th" && val.status === true
  )
) {
  tabs.push({ label: "TH", component: <THContent track={track} /> });
}

if (
  track?.roles?.some(
    (val) => val.role === "requestor" && val.status === true
  )
) {
  tabs.push({ label: "Requestor", component: <Requestor track={track} /> });
}


  return (
    <div>
       <Typography variant="h4" align="center">
        {track?.track_name}
      </Typography>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
        {tabs.map((tab, i) => (
              <Tab key={i} label={tab.label} {...a11yProps(i)} />
            ))}
        </Tabs>
      </Box>
     {tabs.map((tab, i) => (
          <CustomTabPanel key={i} value={value} index={i}>
            {tab.component}
          </CustomTabPanel>
        ))}
    </Box>
    </div> 
  )
}
export default Track;